export default __webpack_public_path__ + "static/media/booo.db962ca1d92707416f697d07d3df53c6.svg";